import * as React from 'react';

const SvgCocktailGlass = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={54} height={54} fill="none" {...props}>
    <path
      d="M18.567 50.22h13.5M25.317 50.22V29.16M1.692 1.62h6.35c1.278 0 2.447.693 3.019 1.79l4.131 7.93"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M42.106 11.34c.477 0 .93.194 1.25.533.32.34.477.792.431 1.247-.955 9.105-8.938 16.037-18.471 16.037S7.799 22.225 6.844 13.12c-.046-.456.11-.909.43-1.248.32-.34.774-.533 1.251-.534l33.581.002z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.613 11.353c-.72-3.358.837-6.787 3.89-8.564 3.054-1.777 6.942-1.517 9.71.649 2.767 2.166 3.815 5.77 2.616 8.999-1.198 3.229-4.383 5.384-7.954 5.383-.413 0-.826-.03-1.235-.087"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgCocktailGlass;
